import type { Editor } from '@tiptap/core'
import { useEditorState } from '@tiptap/react'

export function useEditorMarkdown(editor: Editor | null): string | undefined {
  return useEditorState({
    editor,
    selector: ({ editor: ed }) => ed?.getMarkdown() ?? undefined,
  }) ?? undefined
}
